const baseUrl = {
  'development': 'http://localhost:4000',
  'staging': 'https://juniper-staging-api.herokuapp.com',
  'production': 'https://api.junipertechnology.co'
}
console.log('baseUrl', baseUrl)
let currentEnv = baseUrl[process.env.REACT_APP_ENVIRONMENT || 'development']

export default currentEnv